import axios from "axios";

let client = axios.create({ baseURL: process.env.VUE_APP_ROOT_API });

export const AuthClient = {
  login(username, password) {
    return client.post(`/login`, {
      username: username,
      password: password
    });
  },
  register(user) {
    return client.post(`/register`, user);
  },
  recovery(username) {
    return client.put(`/recovery`, {
      username: username
    });
  },
  resetPassword(obj) {
    return client.put(`/reset-password`, obj);
  },
  resetPasswordWithToken(obj) {
    return client.put(`/reset-password-token`, obj);
  },
  saveUser(user) {
    localStorage.setItem("token", user.token);
    localStorage.setItem("username", user.username);
    localStorage.setItem("roles", JSON.stringify(user.roles));
  }
};
